var slotRootStyle = 'fx_e395032e_1ucncm00';

export { slotRootStyle };
//# sourceMappingURL=layout.vanilla.mjs.map
